export const GA_EVENT_TYPE = {
    /** 瀏覽桌布頁面 */
    VIEW_WALLPAPEPR_PAGE: 'VIEW_WALLPAPEPR_PAGE',
    /** 瀏覽下載頁面 */
    VIEW_DOWNLOAD_PAGE: 'VIEW_DOWNLOAD_PAGE',
    /** 我的桌布 */
    MY_WALLPAPER: 'MY_WALLPAPER',
    ORIGIN_FROM_BRUSSELS: 'ORIGIN_FROM_BRUSSELS',
    BEAUTIFUL_STORY: 'BEAUTIFUL_STORY',
    /** 前往下載頁面 */
    GO_DOWNLOAD_PAGE: 'GO_DOWNLOAD_PAGE',
    /** 瀏覽桌布綁定系列頁面 */
    VIEW_WALLPAPEPR_SERIES_PAGE: 'VIEW_WALLPAPEPR_SERIES_PAGE'
};

export const GA_PAGE_VIEW_TYPE = {
    /** 進入專屬桌布集錦頁面 */
    view_wallpaper_page: 'view_wallpaper_page',
    /** 進入下載桌布頁面 */
    download_wallpaper: 'download_wallpaper',
    /** 進入收藏系列頁 */
    view_wallpaper_series_page: 'view_wallpaper_series_page'
};

export const EXTERNAL_URL = {
    MY_WALLPAPER: '/',
    ORIGIN_FROM_BRUSSELS: 'https://urli.ai/line/NwiDhDrI',
    BEAUTIFUL_STORY: 'https://urli.ai/line/U6WpwDBY'
};

export const GATYPE = 'ap';

export const MESSAGES = [
    {
        type: 'text',
        text: '專賣店查詢'
    }
];

export const REDIRECT_ROUTE = 'wallpaper';
